import React from "react";
import { TopBar, Logo } from "./styles";
import Menu from "../../components/NavHeader";
import logo from "../../assets/logo_porto_itapoa.png";

// import { Container } from './styles';

function Main({ children, title }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        background: "whitesmoke",
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }}
    >
      <Menu />
      <div style={{ width: "96%", marginLeft: "50px" }}>
        <TopBar>
          <Logo src={logo} style={{ marginLeft: "24px" }} />
          {title ? (
            <h2
              style={{
                margin: 0,
                borderLeft: "0.5px solid #ffffff",
                paddingLeft: 20,
                marginLeft: 20,
                fontWeight: "initial",
                color: "#1e824c",
                fontSize: 22
              }}
            >
              {title}
            </h2>
          ) : null}
        </TopBar>
        <div>{children}</div>
      </div>
    </div>
  );
}

export default Main;
